export const TRACKER_URL = "/event";
export const ERROR_URL = "/errors";
export const METRIKA_ID = 92514939;

// Tracking only ever runs on the production host — previews, Storybook and
// localhost must not pollute the collector or the Metrika counter.
export const TRACKED_HOSTNAME = "lenacareer.ru";

export const SESSION_TTL_MS = 30 * 60 * 1000;
export const BATCH_INTERVAL_MS = 2000;
export const MAX_QUEUE_SIZE = 100;
export const RETRY_MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const RAGE_CLICK_COUNT = 3;
export const RAGE_CLICK_WINDOW_MS = 1000;
export const ENGAGED_THRESHOLD = 2;
export const IDLE_TIMEOUT_MS = 30_000;
export const ENGAGED_SAMPLE_MS = 1_000;
export const ENGAGED_GOAL_THRESHOLD_MS = 30_000;
export const TIME_ON_PAGE_CAP_S = 1800;

export const SESSION_KEY = "_lc_session";
export const ATTRIBUTION_KEY = "_lc_attribution";
export const SESSION_COOKIE_NAME = "_lc_sid";
export const VISITOR_COOKIE_NAME = "_lc_vid";
export const HEADLINE_COOKIE_NAME = "_lc_hv";

export const UUID_V4_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
